<div class="ui-tabs">
  @for (tab of tabs; track tab.value) {
    <button
      type="button"
      [class.on]="activeValue === tab.value"
      (click)="select(tab.value)"
    >
      {{ tab.label }}
      @if (tab.count != null) {
        <span class="ct">{{ tab.count }}</span>
      }
    </button>
  }
</div>
